const headersMap = {
  content: [
    { key: "title", label: "Title" },
    { key: "description", label: "Description" },
    { key: "duration", label: "Duration" },
    { key: "chapter_count", label: "Chapter Count" },
    { key: "tags", label: "Tags" },
    { key: "rfid", label: "RFID" },
    { key: "is_kids_favourite", label: "Is Kids Favourite" },
    { key: "is_all_time_classic", label: "Is All Time Classic" },
    { key: "is_sleep", label: "Is Sleep" },
    { key: "content_type", label: "Content Type" },
    { key: "error", label: "Error" },
  ],
  chapters: [
    { key: "Content Title", label: "Content Title" },
    { key: "title", label: "Title" },
    { key: "duration", label: "Duration" },
    // { key: "order", label: "Order" },
    // { key: "chapter_type", label: "Chapter Type" },
    // { key: "audio_file", label: "audio_file" },
    { key: "songNumber", label: "songNumber" },
    { key: "error", label: "Error" },

  ],
  characters: [
    { key: "Content Title", label: "Content Title" },
    { key: "name", label: "Name" },
    { key: "description", label: "Description" },
    { key: "error", label: "Error" },

  ],
};

export default headersMap;